import './AjudaItem.css';
import React, { useState } from 'react';

const AjudaItem = ({icone, titulo, texto})=>{
    // 1. Definimos o estado: começa como 'false' (escondido)
    const [estaAtivo, setEstaAtivo ] = useState(false);
    // 2. Função para alternar o estado
    const alternarAtivo = () => {
        setEstaAtivo(!estaAtivo);
    };

        return (
            <li className="ajuda__item">
                <h4 className="ajuda__item--titulo">
                    <i className='material-icons' 
                        onClick={alternarAtivo} 
                        style={{ cursor: 'pointer' }}>
                {icone}</i>{titulo}
                </h4>
                {/* 3. Renderização Condicional: Só mostra o <p> se 'estaAtivo' for true 
                
                Se estaAtivo for true: O React ignora o true e olha para o que vem depois do &&. Como o que vem depois é o seu parágrafo <p>, o React o desenha (renderiza) na tela.

                Se estaAtivo for false: O JavaScript para a execução imediatamente. O React entende que não deve renderizar nada naquela posição.
                */}
                {estaAtivo && <p className="ajuda__item--conteudo">{texto}</p>}
            </li>
        );
}

export default AjudaItem;